<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Category Types" title="Category Types" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list page-subtitle">
								<div class="row">
									<div class="col-md-10 d-flex">
										<span style="font-size: 20px; font-weight: bolder;">Manage Types</span>
									</div>
									<div class="col-md-2">
										<button class="btn btn-primary" type="button" data-original-title="test" @click="openModal">Add Types</button>
									</div>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-6 d-flex">
										<label class="d-flex listing-length"><span>Show</span>
											<select class="form-select" v-model="listing_length" @change="fetchCategoryTypes()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									
									<div class="col-md-3">
										<input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchCategoryTypes()" />
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr>
											<th>Name</th>
											<th>Options</th>
										</tr>
									</thead>
									<tbody v-if="Boolean(types.length)">
										<tr v-for="type in types" :key="type.id">
											<td>{{ type.name }}</td>
											<td>
												<a class="btn btn-primary btn-sm mt-2 me-1" @click="editType(type)">Edit</a>

												<a class="btn btn-danger btn-sm mt-2 me-1" @click="deactivateType(type)" v-if="type.status == 1">Deactivate</a>
												<a class="btn btn-success btn-sm mt-2 me-1" @click="activateType(type)" v-else>Activate</a>

											</td>
										</tr>
									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="7" class="text-center">No data</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<nav aria-label="Page navigation" class="mt-2">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchCategories(page.url + '&limit=' + listing_length + '&type=' + type + '&keyword=' + keyword)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->

						</div>

						

					</div>
				</div>
			</div>
		</div>

		<DynamicModal ref="modal" :title="modal_title">
			<template #body>
				<form @submit.prevent="addType" enctype="multipart/form-data">
					<div class="col-md-12 form-group">
						<label class="control-label">Type name <span class="required">*</span></label>
						<input class="form-control" type="text" placeholder="" v-model="type.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"/>
						<div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
							<p class="mb-0">{{ val }}</p>
						</div>
					</div>
                   <div class="mb-3"></div>
					<div class="col-md-12 form-group">
						<button type="submit" class="btn btn-primary me-3" >{{ button_title }}</button>
						<button type="button" class="btn btn-light" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>
		
	</div>
</template>


<script>

import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "CategoriesPage",
		components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},

		data() {
			return {
				types: [],
				type: {
					id: null,
					name: "",
					
				},
				modal_title: "Add Type",
				button_title: "Add",
				pagination: {},
				edit: false,
				status: {
					id: "",
					status: "",
				},
				keyword: "",
				showsearch: false,
				listing_length: 10,
				token: "",
				errors: {},
				activate: false,
         		deactivate: false,

         		active_page_url: null,
			};
		},
		mounted() {
		},

		created() {
			this.fetchCategoryTypes();
		},

		methods: {
			fetchCategoryTypes(page_url = null) {
				let url = "/api/admin/category_type?limit=" + this.listing_length +  "&keyword=" + this.keyword;
				page_url = page_url || url;

				this.active_page_url = page_url;

				this.getToken();
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						this.types = responseData.data;
						this.pagination = responseData.links;
						console.log(responseData);
					})
					.catch((err) => console.log(err));
			},

			

			openModal() {
                this.clearForm(); 
                this.modal_title = "Add Type";
                this.button_title = "Add";
				this.showModal();
			},

			closeModal() {
				this.hideModal();
                this.clearForm();
			},

			getToken() {
                if (localStorage.getItem('slo_admin')) {
                    var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
                    if(slo_admin.token) {

                        this.token = slo_admin.token;
                        this.user = slo_admin;

                    } else {
                        this.$swal("", "Failed to fetch token, please login again", "error");
                        this.$router.push({ name: "Login" });
                    }

                } else {
                    this.$swal("", "Session expired, please login again", "error");
                    this.$router.push({ name: "Login" });
                }
            },

			

			addType() {
                this.getToken();
                let formData = new FormData();
                formData.append("name", this.type.name);
                const config = {
                    headers: {
                        "content-type": "multipart/form-data",
                        Authorization: "Bearer " + this.token,
                    },
                };
                let url;
                if (!this.edit) {
                    url = "/api/admin/category_type/add";
                    this.active_page_url = null;
                } else {
                    url = "/api/admin/category_type/edit";
                    formData.append("id", this.type.id);
                }
                this.$axios
                    .post(url, formData, config)
                    .then((response) => {
                        if (response.data.status === 'true') {
                            this.$swal("", response.data.message, "success");
                        } else {
                            this.$swal("", response.data.message, "error");
                        }
                        this.clearForm();
                        this.closeModal();
                        this.fetchCategoryTypes(this.active_page_url);
                    })
                    .catch((error) => {
                        console.error('Error:', error); // Log error details
                        if (error.response) {
                            if (error.response.data.message) {
                                this.errors = error.response.data.message;
                                this.$swal("", error.response.data.message, "error");
                            } else {
                                this.$swal("", "Something went wrong", "error");
                            }
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    });
            },



			showModal(modal) {
				this.$refs[modal].show();
			},

			hideModal(modal) {
				this.$refs[modal].hide();
			},

			editType(type) {
				this.edit = true;
				this.type.id = type.id;
				this.type.name = type.name;
				this.errors = {};
				this.modal_title = "Edit Type";
				this.button_title = "Update";
				this.showModal("");
			},
			clearForm() {
				this.edit = false;
				this.type.id = null;
				this.type.name = "";
				this.errors = {};
				
			},
			activateType(type) {
				this.activate = false;
				this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to activate this type?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.status.id = type.id;
						this.status.status = "1";
						this.updateTypeStatus();
					}
					
				});
			},
			deactivateType(type) {
				this.deactivate = false;
				this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to deactivate this type?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.status.id = type.id;
						this.status.status = "0";
						this.updateTypeStatus();
					}
				});
		        
			},
			updateTypeStatus() {
				const config = {
					headers: {
						Authorization: "Bearer " + this.token,
					},
				};
				this.$axios
					.get("/api/admin/category_type/status?id=" + this.status.id + "&status=" + this.status.status, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.fetchCategoryTypes(this.active_page_url);
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},
		},
	};
</script>